import { Component, OnInit, AfterViewInit } from '@angular/core';
import { News, ParsedNewsData, WeaveNews } from '@shared/model/newsdata.model';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { GlobalService, NewsroomService } from '@shared/services';
import { ActivatedRoute } from '@angular/router';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import anime from 'animejs/lib/anime.es.js';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
})
export class NewsComponent implements OnInit, AfterViewInit {
  newsData: News[] = [
    {
      title:
        'XL Axiata Menggandeng Surge (WIFI) Manfaatkan Jaringan Serat Optik di Sepanjang Jalur Kereta',
      published_at: '2022-12-26',
      url: 'https://blog.surge.co.id/xl-axiata-menggandeng-surge-wifi-manfaatkan-fiber-optik/',
    },
    {
      title:
        'SURGE (WIFI) GANDENG SINERGY NETWORKS, PERLUAS KAPASITAS JARINGAN BIDIK PENDAPATAN 821 M',
      published_at: '2022-10-04',
      url: 'https://blog.surge.co.id/gandeng-sinergy-networks-untuk-perluas-kapasitas-jaringan-surge-wifi-bidik-pendapatan-miliyaran/',
    },
    {
      title: 'Huawei Indonesia Gandeng Surge (WIFI), Manfaatkan Teknologi CDN',
      published_at: '2022-06-16',
      url: 'https://blog.surge.co.id/huawei-indonesia-gandeng-surge-wifi-manfaatkan-teknologi-cdn/',
    },
    {
      title: 'Punya Wi-Fi Cepat Kelas Dunia, Stasiun Bogor Pecahkan Rekor MURI',
      published_at: '2022-04-04',
      url: 'https://blog.surge.co.id/punya-wi-fi-cepat-kelas-dunia-stasiun-bogor-pecahkan-rekor-muri/',
    },
    {
      title:
        'Weave Gandeng PGNCOM Kembangkan Utilisasi Jaringan Telekomunikasi',
      published_at: '2021-12-14',
      url: 'https://blog.surge.co.id/weave-gandeng-pgncom-kembangkan-utilisasi-jaringan-telekomunikasi/',
    },
    {
      title:
        'Anak Usaha Surge (WIFI) dan Mitsui & Co., Ltd. Jajaki Rencana Kerjasama Untuk Pembangunan Serat Optik di Indonesia',
      published_at: '2021-11-04',
      url: 'https://blog.surge.co.id/mitsui-dan-co-ltd-pembangunan-serat-optik-di-indonesia/',
    },
  ];
  newsList: WeaveNews[] = [];
  highlightNewsList: WeaveNews[] = [];
  pageCtr = 1;
  totalItems = 0;
  itemsPerPage = 6;
  currentLang = '';
  token = '';

  constructor(
    private gs: GlobalService,
    private newsService: NewsroomService,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.refresh(true);

    this.getData(this.pageCtr);

    this.token = this.newsService.surgeApiToken;
    this.currentLang = this.translate.currentLang;
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
    });
  }

  ngAfterViewInit(): void {
    this.gs.scrollIntoView(this.route);

    anime.timeline({ loop: false }).add({
      targets: '.title .text-wrapper',
      translateY: [100, 0],
      easing: 'easeOutExpo',
      duration: 2000,
      delay: function (el, i) {
        return 30 * i;
      },
    });
  }

  pageChanged(event: PageChangedEvent): void {
    this.getData(event.page);
  }

  parseNews(text: string): ParsedNewsData {
    return JSON.parse(text);
  }

  getData(page: number) {
    this.newsService.getWeaveNews(page, this.itemsPerPage).then((res: any) => {
      const newsList: WeaveNews[] = res.data.data;
      this.pageCtr = page;
      this.newsList = newsList.map((news) => {
        return {
          ...news,
          created_at: new Date(news.created_at),
          parsed_content: this.parseNews(news.content),
          parsed_meta_desc: this.parseNews(news.meta_desc),
          parsed_meta_tag: this.parseNews(news.meta_tag),
          parsed_meta_title: this.parseNews(news.meta_title),
          parsed_og_desc: this.parseNews(news.og_desc),
          parsed_og_title: this.parseNews(news.og_title),
          parsed_short_desc: this.parseNews(news.short_desc),
          parsed_title: this.parseNews(news.title),
        };
      });
      this.totalItems = res.data.total;

      const highlight: WeaveNews[] = res.highlights;
      this.highlightNewsList = highlight.slice(0, 2).map((news) => {
        return {
          ...news,
          parsed_content: this.parseNews(news.content),
          parsed_meta_desc: this.parseNews(news.meta_desc),
          parsed_meta_tag: this.parseNews(news.meta_tag),
          parsed_meta_title: this.parseNews(news.meta_title),
          parsed_og_desc: this.parseNews(news.og_desc),
          parsed_og_title: this.parseNews(news.og_title),
          parsed_short_desc: this.parseNews(news.short_desc),
          parsed_title: this.parseNews(news.title),
        };
      });
    });
  }
}
